import { contractTypeEnum } from "./enums";

export type ContractTypeApi =
  | "b2B"
  | "employmentContract"
  | "contractOfMandate"
  | "intern";

const apiToEnum: Record<ContractTypeApi, contractTypeEnum> = {
  b2B: contractTypeEnum.B2B,
  employmentContract: contractTypeEnum.EmploymentContract,
  contractOfMandate: contractTypeEnum.ContractOfMandate,
  intern: contractTypeEnum.Intern,
};

export const contractTypePl: Record<contractTypeEnum, string> = {
  [contractTypeEnum.B2B]: "Umowa B2B",
  [contractTypeEnum.EmploymentContract]: "Umowa o pracę",
  [contractTypeEnum.ContractOfMandate]: "Umowa zlecenie",
  [contractTypeEnum.Intern]: "Praktykant/Stażysta",
};

export function parseContractType(
  value: ContractTypeApi | null | undefined
): contractTypeEnum | null {
  if (value === null || value === undefined) {
    return null;
  }
  return apiToEnum[value] ?? null;
}

export function getContractTypeLabel(
  value: ContractTypeApi | null | undefined
): string {
  const parsed = parseContractType(value);
  if (parsed === null) {
    return "—";
  }
  return contractTypePl[parsed];
}

export function isPayoutOnlyContract(
  value: ContractTypeApi | null | undefined
): boolean {
  const parsed = parseContractType(value);
  return (
    parsed === contractTypeEnum.B2B
    || parsed === contractTypeEnum.ContractOfMandate
    || parsed === contractTypeEnum.Intern
  );
}

export function isEmploymentContract(
  value: ContractTypeApi | null | undefined
): boolean {
  return parseContractType(value) === contractTypeEnum.EmploymentContract;
}

export function isInternContract(
  value: ContractTypeApi | null | undefined
): boolean {
  return parseContractType(value) === contractTypeEnum.Intern;
}
